// extracted by mini-css-extract-plugin
module.exports = {"customButton":"customButton_customButton__3AwJX","black":"customButton_black__2vlpY","gold":"customButton_gold__3fiML"};